import React, { useCallback } from 'react';
import GridLayout from '../../../../shared/ui/GridLayout';
import Field from '../../../../shared/ui/Field';
import {
  useFieldController,
  useFormWatch,
} from '../../../../../../helpers/formManager';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import {
  dateTime,
  getDisabledDateForPicker,
} from '../../../../shared/packages/dateTime';

const ToBody = ({ control, fromDate, toDate, disabled, changeCb }) => {
  return (
    <>
      <GridLayout adaptive>
        <Field.Memoized
          type={Field.types.datePicker}
          formItemLabel="Дата начала"
          value={fromDate}
          disabled
        />
        <ToField
          control={control}
          defaultValue={toDate}
          fromDate={fromDate}
          disabled={disabled}
          changeCb={changeCb}
        />
      </GridLayout>
      <NewConfigBlock defaultValue={toDate} control={control} />
    </>
  );
};

export default ToBody;

function ToField({ control, defaultValue, fromDate, disabled, changeCb }) {
  const { field, fieldState } = useFieldController({
    name: fieldNames.main.toDate,
    defaultValue,
    control,
    rules: {
      required: 'Укажите дату',
      validate: (value) => {
        if (!value) return;

        if (value.isSame(defaultValue, 'day')) {
          return 'Дата окончания не изменена';
        }

        if (value.isSameOrBefore(dateTime(), 'day')) {
          return 'Дата окончания не может быть раньше текущей даты';
        }
      },
    },
  });

  const disabledDate = useCallback(
    (date) => getDisabledDateForPicker(fromDate, date),
    [fromDate]
  );

  const handleChange = (date) => {
    field.onChange(date);
    changeCb();
  };

  return (
    <Field.Memoized
      type={Field.types.datePicker}
      formItemLabel="Дата окончания"
      required
      errorMessage={fieldState.error?.message}
      disabledDate={disabledDate}
      value={field.value}
      onChange={handleChange}
      disabled={disabled}
    />
  );
}

function NewConfigBlock({ defaultValue, control }) {
  const toDate = useFormWatch({
    control,
    name: fieldNames.main.toDate,
    exact: true,
  });

  if (toDate?.isAfter(defaultValue, 'day')) {
    return <NewConfigCheckbox control={control} />;
  }

  return null;
}

function NewConfigCheckbox({ control }) {
  const { field } = useFieldController({
    name: 'newConfig',
    shouldUnregister: true,
    control,
  });

  return (
    <Field.Memoized
      type={Field.types.checkbox}
      checked={field.value}
      onChange={field.onChange}
    >
      Создать новую конфигурацию помещений
    </Field.Memoized>
  );
}
